class ReadMore extends HTMLElement {
  constructor() {
    super();

    this.ACTIVE_CLASS = "read-more--active";
    this.TRUNCATED_CLASS = "read-more--truncated";

    this.isMobile = window.matchMedia("(max-width: 990px)").matches;
    this.toggle = this.querySelector(".js-truncate-toggle");
    this.content = this.querySelector(".read-more__content");
    this.height = undefined;
    this.contentHeight = this.content.scrollHeight;
    this.truncation = this.dataset.truncation;
    this.truncationMobile = this.dataset.truncationMobile;

    this.init();
  }

  init() {
    this.setTruncationHeight();

    if (this.truncationHeight > 0) {
      // First, let content be at full height to measure it
      this.content.style.height = 'auto';
      this.contentHeight = this.content.scrollHeight;
      
      // Calculate what the truncated height would be
      const lineHeight = parseFloat(getComputedStyle(this.content).lineHeight);
      const truncatedHeight = this.truncationHeight * lineHeight;
      this.setHeight = truncatedHeight;
      this.height = `${truncatedHeight}px`;
      
      // Check if content actually needs truncation (add small buffer for rounding)
      if (this.contentHeight > truncatedHeight + 1) {
        // Content exceeds limit, apply truncation
        this.content.style.height = this.height;
        this.content.classList.add(this.TRUNCATED_CLASS);
        this.toggle.classList.add("read-more__button--active");
        this.addListener();
      } else {
        // Content fits, keep it at auto height and hide button
        this.content.style.height = 'auto';
      }
    } else {
      // No truncation set
      this.content.style.height = 'auto';
    }
  }

  setTruncationHeight() {
    const truncationMobile = this.truncationMobile > 0 ? this.truncationMobile : this.truncation;

    this.truncationHeight = this.isMobile ? truncationMobile : this.truncation;
  }

  setTruncatedHeight() {
    const lineHeight = parseFloat(getComputedStyle(this.content).lineHeight);
    const height = this.truncationHeight * lineHeight;

    this.height = `${height}px`;
    this.setHeight = height;
  }

  addListener() {
    this.toggle.addEventListener("click", () => this.toggleContent());
  }

  toggleContent() {
    this.classList.contains(this.ACTIVE_CLASS) ? this.reduceContent() : this.expandContent();
  }

  expandContent() {
    this.classList.add(this.ACTIVE_CLASS);
    this.content.classList.remove(this.TRUNCATED_CLASS);

    const width = getComputedStyle(this.content).width;

    // Set properties to calculate height whilst hiding element
    this.content.style.width = width;
    this.content.style.position = 'absolute';
    this.content.style.visibility = 'hidden';
    this.content.style.height = 'auto';

    const height = getComputedStyle(this.content).height;

    // Reset properties used above to calculate height
    this.content.style.width = null;
    this.content.style.position = null;
    this.content.style.visibility = null;
    this.content.style.height = this.height;

    // Force repaint
    getComputedStyle(this.content).height;
    requestAnimationFrame(() => this.content.style.height = height);

    this.content.addEventListener("transitionend", () => {
      if (this.classList.contains(this.ACTIVE_CLASS)) this.content.style.height = "auto";
    });
  }

  reduceContent() {
    this.classList.remove(this.ACTIVE_CLASS);
    this.content.classList.add(this.TRUNCATED_CLASS);

    this.content.style.height = getComputedStyle(this.content).height;

    // Force repaint
    getComputedStyle(this.content).height;

    requestAnimationFrame(() => this.content.style.height = this.height);
  }
}

customElements.define("read-more", ReadMore);